export default __webpack_public_path__ + "static/media/Ellipsis.0a64655a.svg";